module.exports = __webpack_public_path__ + "img/auction-3.66039d23.png";